"use client";
import React from "react";
import { usePathname } from "next/navigation";
import DocsSidebar from "@/components/docs/DocsSidebar";
import { TableOfContents } from "@/components/docs/TableOfContents";
import { BACKEND_SECTIONS, DATABASE_SECTIONS, ABOUT_SECTIONS, ARCHITECTURE_SECTIONS } from "./data";

export default function DocsLayout({
    children,
}: {
    children: React.ReactNode;
}) {
    const pathname = usePathname();

    // Determine which sections to show in TOC based on current page
    const getSectionsForPage = () => {
        if (pathname === "/docs/about") {
            return ABOUT_SECTIONS;
        } else if (pathname === "/docs/backend") {
            return [...BACKEND_SECTIONS, ...ARCHITECTURE_SECTIONS];
        }
        // Main docs page shows Database sections
        return DATABASE_SECTIONS;
    };

    const currentSections = getSectionsForPage();

    return (
        <div className="flex h-screen bg-background overflow-hidden">
            <DocsSidebar />
            <main className="flex-1 overflow-y-auto">
                <div className="">
                    {children}
                </div>
            </main>

            <div className="w-64 h-full p-8 hidden lg:block border-l border-border bg-background/30 backdrop-blur-sm">
                <h3 className="text-sm font-bold text-primary-text mb-4">On this page</h3>
                <TableOfContents sections={currentSections.map(s => ({ id: s.id, title: s.title }))} />
            </div>
        </div>
    );
}
